import {createAction} from 'redux-actions';
import {ContactData} from '../pages/bookings/BookingPage';

export interface FetchBookingDetailsPayload {
    bookingId: string;
}

export interface FetchMultipleBookingDetailsPayload {
    bookingIds: string;
}

export interface RebookCustomerDoorPayload {
    bookingId: string;
    depotId: string;
    orderItemId: string;
    doorNumber: number;
}

export interface FinishRentalPayload {
    orderId: string;
    items: string[];
}

export interface StartRentalPayload {
    orderId: string;
    items: string[];
}

export interface CreateNewOrderPayload {
    groupId: string;
    fromDate: Date;
    // `HH:mm` of the picked availability slot (see `visitorBookingWindow`).
    bookingTime?: string;
    duration: number;
    contactData: ContactData;
    comment: string;
    isGuestBooking?: boolean;
    // #3219: the location's zone the window is built on; the station default when absent.
    timeZone?: string;
}

export interface FetchVisitorBookingsPayload {
}

/* eslint-disable max-len */
export const fetchBookingDetails = createAction<FetchBookingDetailsPayload>('FETCH_BOOKING_DETAILS');
export const fetchMultipleBookingDetails = createAction<FetchMultipleBookingDetailsPayload>('FETCH_MULTIPLE_BOOKING_DETAILS');
export const fetchVisitorBookings = createAction<FetchVisitorBookingsPayload>('FETCH_VISITOR_BOOKINGS');
export const rebookCustomerDoor = createAction<RebookCustomerDoorPayload>('REBOOK_CUSTOMER_DOOR');
export const finishRental = createAction<FinishRentalPayload>('FINISH_RENTAL');
export const startRental = createAction<StartRentalPayload>('START_RENTAL');
export const createNewOrder = createAction<CreateNewOrderPayload>('CREATE_NEW_ORDER');
